import io, { Socket } from "socket.io-client";
import { IArray } from "../../models";
import { AuctionTypes } from "./auctions.types";
import { dataConstants } from "../../constants/data-constants";
import {
  setErrorMsg,
  setLoading,
  setSuccessMsg,
} from "../common/common.actions";
import { formatString } from "../../utils/utility-functions";
import { axiosClient } from "../../utils/axios-config";
import { store } from "../store";

//************************ Synchronous Actions **************************//

export const setSelectedVarieties = (varieties: Array<IArray>): any => {
  return {
    type: AuctionTypes.SET_SELECTED_VARIETIES,
    payload: varieties,
  };
};
export const setSelectedHubs = (hubs: Array<IArray>): any => {
  return {
    type: AuctionTypes.SET_SELECTED_HUBS,
    payload: hubs,
  };
};
export const setSelectedClaims = (claims: Array<IArray>): any => {
  return {
    type: AuctionTypes.SET_SELECTED_CLAIMS,
    payload: claims,
  };
};
export const setStartDate = (date: string): any => {
  return {
    type: AuctionTypes.SET_START_DATE,
    payload: date,
  };
};
export const setEndDate = (date: string): any => {
  return {
    type: AuctionTypes.SET_END_DATE,
    payload: date,
  };
};
export const setActiveAuction = (content: any): any => {
  return {
    type: AuctionTypes.SET_ACTIVE_AUCTION,
    payload: content,
  };
};
export const setUpcomingAuction = (content: any): any => {
  return {
    type: AuctionTypes.SET_UPCOMING_AUCTION,
    payload: content,
  };
};
export const setBids = (content: any): any => {
  return {
    type: AuctionTypes.SET_BIDS_EVENT,
    payload: content,
  };
};
export const setWins = (content: any): any => {
  return {
    type: AuctionTypes.SET_WINS_EVENT,
    payload: content,
  };
};
export const setReport = (content: any): any => {
  return {
    type: AuctionTypes.SET_REPORT_EVENT,
    payload: content,
  };
};
export const resetAuctionData = (): any => {
  return {
    type: AuctionTypes.RESET_AUCTION_DATA,
  };
};
export const setSocket = (socket: Socket) => ({
  type: AuctionTypes.SET_SOCKET,
  payload: socket,
});
export const setCounts = (content: any) => ({
  type: AuctionTypes.SET_COUNT_EVENT,
  payload: content,
});

//************************ Asynchronous Socket Actions **************************//
export const startSocketConnection = (): any => {
  return (dispatch: any, getState: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      const socket = io(dataConstants.socketURL, {
        // query: {
        //   Authorization: getState().user.authData.access_token,
        // },
        // auth: {
        //   token: getState().user.authData.access_token,
        // },
        transports: ["websocket"],
      });
      socket.on("connect", () => {
        socket.emit("authenticate", {
          token: getState().user.authData.access_token,
        });
        // dispatch(setSuccessMsg("Socket connection established successfully!"));
        dispatch(setLoading(false));
        dispatch(setSocket(socket));
        resolve(true);
      });
      socket.on("connect_error", (error: any) => {
        // dispatch(setErrorMsg("Socket connection could not be established."));
        dispatch(setLoading(false));
        reject(false);
      });
    });
  };
};

export const sendSocketData = (eventID: string, data: any): any => {
  return (dispatch: any, getState: any) => {
    // dispatch(setLoading(true));
    const socket = getState().auction.socket;
    Object.entries(data).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length === 0) {
        data[key] = undefined;
      }
    });
    socket && socket.emit(eventID, data, (response: any) => {
      if (response?.error) {
        dispatch(
          setErrorMsg(
            `Please refresh the page to send ${formatString(eventID)}.`
          )
        );
        dispatch(setLoading(false));
      } else {
        dispatch(setLoading(false));
      }
    });
  };
};

export const getSocketData = (eventID: string): any => {
  return (dispatch: any, getState: any) => {
    return new Promise((resolve, reject) => {
      // dispatch(setLoading(true));
      const socket = getState().auction.socket;
      socket && socket.on(eventID, (response: any) => {
        // dispatch(setLoading(false));
        // dispatch(
        //   setSuccessMsg(`${formatString(eventID)} fetched successfully.`)
        // );
        switch (eventID) {
          case "trader_active_auctions":
            dispatch(setActiveAuction(response));
            break;
          case "trader_upcoming_auctions":
            dispatch(setUpcomingAuction(response));
            break;
          case "my_bids":
            dispatch(setBids(response));
            break;
          case "my_wins":
            dispatch(setWins(response));
            break;
          case "my_orders":
            dispatch(setReport(response));
            break;
          default:
            return resolve(response);
        }
      });
      socket && socket.on("on_error", (response: any) => {
        // console.error(response);
        dispatch(
          setErrorMsg(
            `Please refresh the page to fetch ${formatString(eventID)}.`
          )
        );
        dispatch(setLoading(false));
      });
    });
  };
};

export const stopSocketConnection = (): any => {
  return (dispatch: any, getState: any) => {
    dispatch(setLoading(true));
    const socket = getState().auction.socket;
    socket.disconnect();
    dispatch(setSocket(null));
    dispatch(setLoading(false));
  };
};

//************************ Asynchronous Actions **************************//
export const fetchRebateMatrix = (data: {
  rebate_id: any;
  branch_id: any;
  crop_id: any;
}): any => {
  return async (dispatch: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.getRebateMatrixUrl, data)
        .then((response) => {
          dispatch(setLoading(false));
          // dispatch(setSuccessMsg("Rebate matrix fetched successfully."));
          return resolve(response.data.data);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(setErrorMsg("Rebate matrix could not be fetched."));
          return resolve(false);
        });
    });
  };
};

export const updateRebateAgreement = (data: { auction_id: any }): any => {
  return async (dispatch: any, getState: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .put(dataConstants.updateRebateUrl, data)
        .then((response) => {
          dispatch(setLoading(false));
          // dispatch(setSuccessMsg("Rebate agreement updated successfully."));
          const activeData = getState().auction.activeData;

          const updatedAuctions = activeData.map((item: any) =>
            item.auction_id === data.auction_id
              ? { ...item, rebate_agreement: 1 }
              : item
          );

          dispatch(setActiveAuction(updatedAuctions));
          return resolve(true);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(setErrorMsg("Rebate agreement could not be updated."));
          return resolve(false);
        });
    });
  };
};

export const updateTCAgreement = (data: { auction_id: any }): any => {
  return async (dispatch: any, getState: any) => {
    return new Promise((resolve, reject) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.postTCUrl, data)
        .then((response) => {
          dispatch(setLoading(false));
          /* dispatch(
            setSuccessMsg("Terms & Conditions agreement updated successfully.")
          ); */
          const activeData = getState().auction.activeData;

          const updatedAuctions = activeData.map((item: any) =>
            item.auction_id === data.auction_id
              ? { ...item, tc_agreement: 1 }
              : item
          );

          dispatch(setActiveAuction(updatedAuctions));
          return resolve(true);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(
            setErrorMsg("Terms & Conditions agreement could not be updated.")
          );
          return resolve(false);
        });
    });
  };
};

export const fetchActiveBids = (data: { auction_id: any }): any => {
  return (dispatch: any) => {
    return new Promise((resolve) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.getActiveBidsUrl, data)
        .then((response) => {
          dispatch(setLoading(false));
          // dispatch(setSuccessMsg("Active Bids fetched successfully."));
          return resolve(response.data.data);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(setErrorMsg("Active Bids could not be fetched."));
        });
    });
  };
};
export const fetchOrderReports = (data: { po_number?: any, supplier_id?: number, download?: boolean }): any => {
  return (dispatch: any) => {
    return new Promise((resolve) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.getOrderDetailsUrl, data, {
          responseType: data.download ? 'blob' : 'json',
        })
        .then((response) => {
          dispatch(setLoading(false));
          // dispatch(setSuccessMsg("Active Bids fetched successfully."));
          return data.download ? resolve(response.data) : resolve(response.data.data);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(setErrorMsg("Order Details could not be fetched."));
        });
    });
  };
};
export const exportOrderReports = (): any => {
  return (dispatch: any) => {
    return new Promise((resolve) => {
      dispatch(setLoading(true));
      const orderParams = {
        crop_id: [store.getState().common.selectedCrop],
        branch_id: [store.getState().common.selectedBranch],
        hub_id: store.getState().auction.selectedHubs,
        variety_id: store.getState().auction.selectedVarieties,
        claim_type: store.getState().auction.selectedClaims,
        delivery_status: store.getState().common.selectedDeliveryStatus && [store.getState().common.selectedDeliveryStatus],
        po_status: store.getState().common.selectedPoStatus && [store.getState().common.selectedPoStatus],
        payment_status: store.getState().common.selectedPayment && [store.getState().common.selectedPayment],
        start_date: store.getState().auction.startDate,
        end_date: store.getState().auction.endDate,
        vendor_code: store.getState().common.vendorCode,
        po_number: store.getState().common.poNumber,
      };
      axiosClient
        .post(dataConstants.exportOrderDetailsUrl, orderParams, {
          responseType: 'blob',
        })
        .then((response) => {
          dispatch(setLoading(false));
          return resolve(response.data);
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(setErrorMsg("No records found."));
        });
    });
  };
};

export const submitBids = (data: {
  auction_id: any;
  branch_id: any;
  bid_qty: number;
  bid_price: number;
  bid_id?: any;
}): any => {
  return (dispatch: any) => {
    return new Promise((resolve) => {
      dispatch(setLoading(true));
      axiosClient
        .post(dataConstants.postBidUrl, data)
        .then((response) => {
          dispatch(setLoading(false));
          if (response.data.status) {
            dispatch(setSuccessMsg("Bids submitted successfully."));
            return resolve(response);
          } else {
            dispatch(setErrorMsg("Bids could not be submitted."));
          }
        })
        .catch((error) => {
          dispatch(setLoading(false));
          dispatch(setErrorMsg("Bids could not be submitted."));
          return resolve(false);
        });
    });
  };
};
